var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options.showFooter
    ? _c("div", { staticClass: "modal-footer" }, [
        _c("div", { staticClass: "modal-footer-left-item" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-footer-center-item" },
          [
            _vm.options.component
              ? _c(_vm.options.component, { tag: "component" })
              : _vm._e(),
            _vm._v(" "),
            _c("BaseButton", {
              attrs: {
                title: _vm.options.confirmTitle,
                classNames: ["button--modifier"],
                ariaLabel: _vm.options.confirmTitle
              },
              nativeOn: {
                click: function($event) {
                  return _vm.confirmationPressed($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer-right-item" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be21528a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be21528a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global-modal/ContentModalFooter.vue
// module id = null
// module chunks = 